import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { isEqual } from 'lodash'

import { AutoComplete, Modal } from '../../../../../components'
import { debounce, THEMES } from '../../../../../utils'

import './search.component.scss'


/**
 * Format Label
 * @param props
 */
const formatLabel = (props) => {
  const {data} = props
  const job = (data && data.jobs && data.jobs.length) || null
  const institution = (job && job.institution_name) || null

  return (
    <div className='label'>
      <div className='label--name'>{data.full_name}</div>
      {institution ? <div className='label--institution'>{institution}</div> : null}
    </div>
  )
}

/**
 * Contact Search Modal
 */
class ContactSearch extends PureComponent {
  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      error: false,
      contact: null,
      contacts: []
    }
  }

  /**
   * Component Did Update
   * @param prevProps
   * @param prevState
   */
  componentDidUpdate (prevProps, prevState) {
    const { suggestions } = this.props
    const { contact } = this.state

    if (!isEqual(suggestions, prevProps.suggestions)) {
      this.setState({
        contacts: this.getContactOptions(suggestions)
      })
    }

    if (contact !== prevState.contact) {
      this.validate()
    }
  }

  /**
   * ComponentWillUnmount
   */
  componentWillUnmount () {
    const { clearSearchResults } = this.props
    this.searchContacts.cancel() // reset debounce
    clearSearchResults()
  }

  /**
   * On field value change search contacts
   */
  searchContacts = debounce((value) => {
    const { searchContacts, clearSearchResults, _organizations } = this.props;
    (_organizations && _organizations.length && value && value.length) ?
      searchContacts({ query: value, organizations: _organizations }) : clearSearchResults()
  })

  /**
   * Normalize contact dropdown options
   * @param suggestions
   * @returns {{label: string, value: *}[]}
   */
  getContactOptions = (suggestions) => {
    return (suggestions || []).map((suggestion) => {
      const job = (suggestion.jobs && suggestion.jobs.length && suggestion.jobs[0]) || {}

      return {
        label: <>
          {suggestion.full_name}
          <span className='autocomplete__detail'>{job.institution_name}</span>
        </>,
        value: suggestion._id,
        data: suggestion
      }
    })
  }

  /**
   * On Contact Update
   */
  onUpdate () {
    const { onMasterUpdate } = this.props
    const { contact } = this.state

    if (!contact || !contact._id) {
      this.validate()
      return
    }

    onMasterUpdate(contact)
  }

  /**
   * Handle contact selection change
   * @param option
   */
  handleContactChange (option) {
    this.setState({ contact: option && option.data })
  }

  /**
   * Validation
   */
  validate () {
    const { contact } = this.state
    const id = (contact && contact._id) || null

    this.setState({
      error: !id
    })
  }

  /**
   * Render
   * @return {*}
   */
  render () {
    const { contactId, loading, onClose } = this.props
    const { error, contact, contacts } = this.state

    const buttons = [
      {
        label: 'Cancel',
        ui: 'shaded',
        onClick: onClose
      },
      {
        label: 'Update Contact',
        ui: THEMES.CITRUS,
        onClick: () => this.onUpdate(contactId || contact)
      }
    ]

    return (
      <Modal
        visible
        className='contact-search'
        title='Search for a Contact Match'
        buttons={buttons}
        onClose={onClose}>
        <div className='field field--text field--full'>
          <label className='field_label'>Search Contact <span className='required'>(required)</span></label>
          <AutoComplete
            error={{ isError: error }}
            loading={loading}
            showDropdownIndicator={false}
            options={contacts}
            isLocal={false}
            onInputChange={this.searchContacts}
            formatOptionLabel={formatLabel}
            onChange={(option) => this.handleContactChange(option)} />
        </div>
      </Modal>
    )
  }
}

ContactSearch.propTypes = {
  loading: PropTypes.bool,
  suggestions: PropTypes.array,
  searchContacts: PropTypes.func.isRequired,
  clearSearchResults: PropTypes.func.isRequired,
  onMasterUpdate: PropTypes.func.isRequired
}

ContactSearch.defaultProps = {
  loading: false,
  suggestions: []
}

export default ContactSearch
